import { AddCircle, Pending, CheckCircle, Cancel, Warning } from '@mui/icons-material';

export const orderStatuses = [
  { name: 'New', value: 'new', color: 'info', icon: <AddCircle fontSize={'small'} /> },
  { name: 'Processed', value: 'processed', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Ready', value: 'ready', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Unpaid', value: 'unpaid', color: 'danger', icon: <Warning fontSize={'small'} /> },
  { name: 'Called', value: 'called', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Unresponsive', value: 'unresponsive', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Shipping', value: 'shipping', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Completed', value: 'completed', color: 'success', icon: <CheckCircle fontSize={'small'} /> },
  { name: 'Canceled', value: 'canceled', color: 'error', icon: <Cancel fontSize={'small'} /> },
];

export const productStatuses = [
  { name: 'New', value: 'new', color: 'info', icon: <AddCircle fontSize={'small'} /> },
  { name: 'Processed', value: 'processed', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Ordered', value: 'ordered', color: 'warning', icon: <Pending fontSize={'small'} /> },
  { name: 'Backorder', value: 'backorder', color: 'danger', icon: <CheckCircle fontSize={'small'} /> },
  { name: 'Received', value: 'received', color: 'success', icon: <CheckCircle fontSize={'small'} /> },
  { name: 'Delivered', value: 'delivered', color: 'success', icon: <CheckCircle fontSize={'small'} /> },
  { name: 'Canceled', value: 'canceled', color: 'error', icon: <Cancel fontSize={'small'} /> },
];

export const transactionStatuses = [
  { name: 'Purchases', value: 'purchases', color: 'warning' },
  { name: 'Expenses', value: 'expenses', color: 'danger' },
  { name: 'Counter', value: 'counter', color: 'success' },
  { name: 'Personal', value: 'personal', color: 'success' },
  { name: 'Extras', value: 'extras', color: 'danger' },
];

export const transactionCounterStatuses = [
  { name: 'POS', value: 'pos', color: 'success' },
  { name: 'Bank', value: 'bank', color: 'success' },
  { name: 'Cash', value: 'counter', color: 'success' },
  { name: 'Courier', value: 'courier', color: 'success' },
];

export const transactionPersonalStatuses = [
  { name: 'Earnings', value: 'Earnings', color: 'success' },
  { name: 'Expenses', value: 'expenses', color: 'danger' },
];

export const getOrderStatus = (value) => {
  return orderStatuses.find((status) => status.value === value);
};

export const getProductStatus = (value) => {
  return productStatuses.find((status) => status.value === value);
};

export const getTransactionStatus = (value) => {
  return transactionStatuses.find((status) => status.value === value);
};

export const getTransactionCounterStatus = (value) => {
  return transactionCounterStatuses.find((status) => status.value === value);
};

export const getTransactionPersonalStatus = (value) => {
  return transactionPersonalStatuses.find((status) => status.value === value);
};
